module.exports = __webpack_public_path__ + "img/WiFi.b3437aa6.png";